export const GET_AUDIT = "GET_AUDIT";
export const GET_AUDIT_SUCCESS = "GET_AUDIT_SUCCESS"
export const GET_AUDIT_FAIL = "GET_AUDIT_FAIL"
export const GET_AUDIT_RESET = "GET_AUDIT_RESET"
export const GET_FILTERED_AUDIT = "GET_FILTERED_AUDIT";
export const GET_FILTERED_AUDIT_SUCCESS = "GET_FILTERED_AUDIT_SUCCESS"
export const GET_FILTERED_AUDIT_FAIL = "GET_FILTERED_AUDIT_FAIL"
export const GET_FILTERED_AUDIT_RESET = "GET_FILTERED_AUDIT_RESET"